<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <!--<a class="navbar-brand" href="#">Dashboard</a>-->
      <div class="navbar-brand">{{routeName}}</div>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">

        <!--<transition name="fade" mode="out-in">
          <div class="text-center" style="width: 100%">
            <h4 class="m-0">
              <strong>{{routeName}}</strong>
            </h4>
          </div>
        </transition>-->

        <!--<ul class="nav navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li>
          <drop-down tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>
        </ul>-->
        <ul class="navbar-nav ml-auto">
          <!--<li class="nav-item">
            <div class="nav-link user-name">
              {{getUserName.firstName + ' ' + getUserName.lastName}}
                <i class="nc-icon nc-circle-09"></i>
            </div>
          </li>-->
            <drop-down :title="getUserName.firstName + ' ' + getUserName.lastName" class="custom-drop-down">
              <a class="dropdown-item" href="javascript:;">
                  <i class="nc-icon nc-settings-gear-64"></i> Setting
              </a>
              <div class="divider m-0"></div>
              <a @click="logout" class="dropdown-item text-danger" style="cursor: pointer">
                  <i class="nc-icon nc-button-power"></i> logout
              </a>
            </drop-down>
          <!--<li class="nav-item">
            <a @click="logout" class="text-danger logout-btn" >
              <i class="nc-icon nc-button-power"></i>
            </a>
            &lt;!&ndash;<a href="#" class="nav-link">
              <i class="nc-icon nc-button-power"></i>
            </a>&ndash;&gt;
          </li>-->
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      getUserName(){
          return this.$store.getters.userInfo
      }
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
        logout(){
            this.$store.dispatch('AUTH_LOGOUT').then(res => this.$router.push('/login'))
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toggleNotificationDropDown () {
            this.activeNotifications = !this.activeNotifications
        },
        closeDropDown () {
            this.activeNotifications = false
        },
        toggleSidebar () {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        hideSidebar () {
            this.$sidebar.displaySidebar(false)
        }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue